import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GET_DETAILED_NEGOTIATION_OVERVIEW_SUCCESS, SET_EXIT_STATUS_DETIALED_OVERVIEW } from "../../../../redux/Action/actionTypes";
import ModalComponent from "../../../../components/Modal/modal";
import { RootState } from "../../../../redux/Reducer";
import AddPhaseActions from "./addActionCards/addPhaseActions";

interface Props {
  currentStep: number;
  totalSteps: number;
  roundName: string;
  stepChangeHandler: (data: number) => void;
  addStepHandler: (data: number) => void;
  backwardStepChangehandler: () => void;
  saveHandler: (status: string) => void;
  fetchUpdatedCards: () => void;
  closeRoundHandler: () => void;
}

const NavigationButtonsForOverview = ({
  currentStep,
  totalSteps,
  roundName,
  saveHandler,
  stepChangeHandler,
  backwardStepChangehandler,
  addStepHandler,
  fetchUpdatedCards,
  closeRoundHandler
}: Props) => {
  const dispatch = useDispatch();
  const [isExitClick, setIsExitClick] = useState<boolean>(false);
  const [isPopupOpenPrep, setIsPopupOpenPrep] = useState(false);
  const [confirmAddRound, setConfirmAddRound] = useState(false);
  const [closeRoundText, setCloseRoundText] = useState<string>("");
  const [isCloseDisabled, setIsCloseDisabled] = useState<boolean>(false);
  const [isReviewDisabled, setIsReviewDisabled] = useState<boolean>(false);
  const [relatedPhase, setRelatedPhase] = useState<string>("");
  const negotiationStepsData = useSelector(
    (state: RootState) => state.dashboardData?.detailedOverviewData?.planNegotiationActions?.negotiationRoundsDetails
  );
  const negotiationContractData = useSelector(
    (state: RootState) => state.dashboardData?.detailedOverviewData
  );

  const popUpHandlertoAddActions = () => {
    if (currentStep == 0) {
      setRelatedPhase("Preparation")
    }
    else if (currentStep == totalSteps - 1) {
      setRelatedPhase("Finalization")
    }
    else{
      setRelatedPhase("Negotiation rounds")
    }
    setIsPopupOpenPrep(true)
  }
  const togglePopUp = () => {
    setIsPopupOpenPrep(!isPopupOpenPrep)
  }
  const [isClose, setIsClose] = useState<boolean>(false);

  const cancelBtnHandler = () => {
    setIsExitClick(false);
  };

  const exitConfirmHandler = () => {
    const status = "In Review";
    negotiationContractData.planNegotiationActions.negotiationRoundsDetails
      .length &&
      negotiationContractData.planNegotiationActions.negotiationRoundsDetails.map(
        (data: any) => {
          if (data.roundName === "Finalization") {
            data.isRoundClosed = true;
          }
        }
      );
    dispatch({
      type: GET_DETAILED_NEGOTIATION_OVERVIEW_SUCCESS,
      payload: negotiationContractData,
    });
    saveHandler(status);
  };

  const popUpHandler = () => {
    setIsExitClick(!isExitClick);
  };

  const exitHandler = () => {
    const status = "In Progress";
    saveHandler(status);
    dispatch({ type: SET_EXIT_STATUS_DETIALED_OVERVIEW, payload: true });
  };

  const closeHandler = () => {
    setIsClose(false)
  }
  const closeConfirmHandler = () => {
    let roundName = currentStep == 0 ? "Preparation" : `Round${currentStep}`
    negotiationContractData.planNegotiationActions.negotiationRoundsDetails
      .length &&
      negotiationContractData.planNegotiationActions.negotiationRoundsDetails.map(
        (data: any) => {
          if (data.roundName === roundName) {
            data.isRoundClosed = true;
          }
        }
      );
    dispatch({
      type: GET_DETAILED_NEGOTIATION_OVERVIEW_SUCCESS,
      payload: negotiationContractData,
    });
    setIsClose(false)
    closeRoundHandler()
    stepChangeHandler(currentStep + 1)
  }

  const closeModalHandler = () => {
    let isAllClosed: any = [];
    let allStepsArr = ["Preparation", "Round1", "Round2", "Round3", "Round4", "Round5", "Round6", "Round7", "Round8", "Round9", "Round10", "Finalization"]
    for (let i = 0; i < currentStep; i++) {
      let rName = allStepsArr[i]
      console.log("rname", rName, negotiationStepsData[`${rName}`], negotiationStepsData)
      negotiationStepsData?.length && negotiationStepsData.map((data: any) => {
        if (data.roundName === rName) {
          isAllClosed.push(data.isRoundClosed)
        }
      })
    }
    if (currentStep !== 0 && isAllClosed.includes(false)) {
      setCloseRoundText("Please closed previous rounds to close this round.")
    } else {
      setCloseRoundText("Once a round is closed it is read only and cannot be edited any more.")
    }
    setIsClose(true)
  }

  useEffect(() => {
    let roundNameText = currentStep == 0 ? "Preparation" : `Round${currentStep}`
    negotiationStepsData?.length > 0 && negotiationStepsData.map((data: any) => {
      if (data?.roundName == roundNameText) {
        setIsCloseDisabled(data?.isRoundClosed)
      }
    })

    let isAllClosed: any = [];
    let allStepsArr = ["Preparation", "Round1", "Round2", "Round3", "Round4", "Round5", "Round6", "Round7", "Round8", "Round9", "Round10", "Finalization"]
    for (let i = 0; i < currentStep; i++) {
      let rName = allStepsArr[i]
      negotiationStepsData?.length && negotiationStepsData.map((data: any) => {
        if (data.roundName === rName) {
          isAllClosed.push(data.isRoundClosed)
        }
      })
    }
    if (isAllClosed.includes(false)) {
      setIsReviewDisabled(true)
    } else {
      setIsReviewDisabled(false)
    }
  }, [currentStep])


  // Extracted btnLeftLabel logic
  let btnLeftLabel = "";
  if (closeRoundText !== "Please closed previous rounds to close this round.") {
    btnLeftLabel = currentStep === 0 ? "Close Preparation" : "Close Round " + currentStep;
  }

  return (
    <>
      <div className="detailed-negotiation-buttons-box">
        <ModalComponent
          isOpen={isExitClick}
          modalTitle={"Warning"}
          toggle={cancelBtnHandler}
          modalBody="You are about to proceed to the negotiation review. Once you are in the negotiation review you will not be able to returned to the detailed overview. Do you want to proceed?"
          btnLeftHandler={exitConfirmHandler}
          btnLeftLabel={"Review Negotiation"}
          btnRightLabel={"Back"}
        />
        <div className="row">
          <div className="col-4">
            <div className="d-flex align-items-center">
              <button className="Exit-button me-2" onClick={exitHandler}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 25 24"
                  fill="none"
                >
                  <path
                    d="M5.44983 19.0502L18.5503 5.94971M5.44983 5.94971L18.5503 19.0502"
                    stroke="#C50022"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <div className="exit-text">Exit</div>
              </button>
              <button className="add-actions-button" onClick={popUpHandlertoAddActions}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus-lg" style={{ marginRight: '5px' }} viewBox="0 0 16 16">
                  <path fillRule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                </svg>
                Add additional actions</button>
            </div>
          </div>
          <div className="col-8">
            <div className="row">
              <div className="col-12 p-0">
                <div className="negotiation-overview-back-continue-box">
                  <div> {currentStep == totalSteps - 2 ? <div>
                    {currentStep < 10 && <button className="add-next-round-button marginRight" onClick={() => setConfirmAddRound(true)}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus-lg" style={{ marginRight: '5px' }} viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                      </svg>
                      Add Round {currentStep + 1}</button>}
                  </div> : ''}</div>
                  <div>
                    <button
                      disabled={currentStep === 0}
                      className={
                        currentStep === 0
                          ? "btn-disabled stepper-button back-button"
                          : "stepper-button back-button"
                      }
                      onClick={backwardStepChangehandler}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 30 30"
                        fill="none"
                        className="back-icon"
                      >
                        <path
                          d="M11 21L2 12L11 3"
                          stroke="#004A96"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      Back
                    </button>
                  </div>
                  <div>
                    {currentStep === totalSteps - 1 && (
                      <button
                        className={isReviewDisabled ? "stepper-button close-negotiation-button closeDisabled" : "stepper-button close-negotiation-button"}
                        onClick={popUpHandler}
                        disabled={isReviewDisabled}
                      >
                        Review Negotiation
                      </button>
                    )}
                    {currentStep !== totalSteps - 1 && (
                      <div className="alignment-style">
                        <div>
                          <button
                            onClick={() => stepChangeHandler(currentStep + 1)}
                            className="stepper-button continue-button marginRight"
                          >
                            Continue
                          </button>
                        </div>

                        <div>
                          <button
                            onClick={() => closeModalHandler()}
                            className={isCloseDisabled ? "stepper-button continue-button closeDisabled" : "stepper-button continue-button"}
                            disabled={isCloseDisabled}
                          >
                            Close {currentStep == 0 ? "Preparation" : `Round ${currentStep}`}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
         <AddPhaseActions isOpen={isPopupOpenPrep} toggle={togglePopUp} RoundName={roundName} fetchUpdatedCards={fetchUpdatedCards} relatedPhase={ relatedPhase}></AddPhaseActions>
        <ModalComponent
          isOpen={confirmAddRound}
          modalTitle={"Confirmation"}
          toggle={() => setConfirmAddRound(false)}
          modalBody="Are you sure you want to add a new negotiation round?"
          btnLeftHandler={() => {
            setConfirmAddRound(false);
            addStepHandler(currentStep + 1);
          }}
          btnLeftLabel={"Yes"}
          btnRightLabel={"Cancel"}
        />
      </div>
      {isClose &&
        <ModalComponent
          isOpen={isClose}
          modalTitle={"Warning"}
          toggle={closeHandler}
          modalBody={closeRoundText}
          btnLeftHandler={closeConfirmHandler}
          btnLeftLabel={btnLeftLabel}
          btnRightLabel={"Back"}
        />}
    </>
  );
};

export default NavigationButtonsForOverview;
